import { customAxios, IDUSUARIO, FDV_URL } from '../constants';

export default function(codArea='') {

  const config = {

    headers: {
      idUsuario: IDUSUARIO,
    },
  };
  
  return customAxios.get(`${FDV_URL}/ficha-venta/fichas-venta/${codArea}/lista-motivo`, config);

}





// WEBPACK FOOTER //
// ./src/utils/getTipoDesasignacion.js